import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';
import MiTitle from '@/components/title/Title.vue';
import Http from '@/http/Http';

@Options({
    components: {
        'mi-title': MiTitle
    }
})
export default class UserSelf extends BaseVue {
    place: any = [];

    ruleForm = {
        name: '',
        password: '',
        password2: '',
        oldPassword: '',
    };


    submitForm(item: any) {
        if(this.ruleForm.password.length>0){
            if(this.ruleForm.password!=this.ruleForm.password2){
                this.toast_warn('两次密码不一致')
                return
            }
            if(this.ruleForm.oldPassword.length==0){
                this.toast_warn('请上传旧密码')
                return
            }
        }
        this.http.editUser(this.ruleForm).then(res => {
            this.toast_success(res.msg)
            this.resetForm("refForm")
        }).catch(res => {
            this.toast_error(res.msg)
        })
    }

    mounted() {
        super.mounted();
        this.http.getDetail().then(res=>{
            this.ruleForm.name=res.data.name
        })
    }

}
